import type { fhirR4 } from '@smile-cdr/fhirts';

export type DTRNextQuestionResponse = fhirR4.QuestionnaireResponse | fhirR4.Parameters;

export const STANDALONE_MODES = ['crd', 'dtr'] as const;
export type StandaloneMode = (typeof STANDALONE_MODES)[number];
export const DEFAULT_STANDALONE: StandaloneMode = 'crd';

export const PA_NEEDED_CODES = ['auth-needed', 'no-auth', 'conditional', 'satisfied', 'performpa', 'indeterminate'] as const;
export type PaNeededCode = (typeof PA_NEEDED_CODES)[number];

export interface PaNeededExtension {
  url: 'pa-needed';
  valueCode: PaNeededCode;
}

export const DEFAULT_CDS_HOOK = 'order-sign';

export const ALLOWED_LAUNCH_PARAMS = ['iss', 'launch', 'standalone', 'useHook'] as const;
export const LAUNCH_PARAMS_STORAGE_KEY = 'dtr-launch-params';
export const LAUNCH_PARAMS_WARNING_KEY = 'dtr-launch-params-errors';

export interface LaunchOverrides {
  standalone?: string;
  useHook?: string;
}

export function resolveStandaloneMode(value: unknown): StandaloneMode {
  if (!value) return DEFAULT_STANDALONE;
  if (typeof value !== 'string') {
    throw new Error(`Invalid standalone mode: '${value}'. Must be one of: ${STANDALONE_MODES.join(', ')}`);
  }
  const normalized = value.toLowerCase() as StandaloneMode;
  if (STANDALONE_MODES.includes(normalized)) return normalized;
  throw new Error(`Invalid standalone mode: '${value}'. Must be one of: ${STANDALONE_MODES.join(', ')}`);
}

// Intentionally lenient: CDS hooks are an open set validated at runtime by discovery,
// not a closed enum. Unknown values are passed through to the CDS service endpoint.
export function resolveCdsHook(value: unknown): string {
  return typeof value === 'string' && value.length > 0
    ? value
    : DEFAULT_CDS_HOOK;
}
